// usePlantillasXL - S48.1.
// Hook simple que expone el catalogo de plantillas tipadas. Las plantillas
// son estaticas (JSON), pero se exponen como hook para tener una API
// unificada (consistente con los otros hooks XL del modulo).
import { useMemo } from 'react';
import { TEMPLATES, findTemplate } from '../templates';

export default function usePlantillasXL() {
  const list = useMemo(() => TEMPLATES.slice(), []);
  return {
    list: list,
    findTemplate: findTemplate,
  };
}
